"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconRadio = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M15.17 10.7A10.28 10.28 0 1 0 25.45 21a10.28 10.28 0 0 0-10.28-10.3zm0 17.53A7.25 7.25 0 1 1 22.42 21a7.26 7.26 0 0 1-7.25 7.23zM15.17 38.76A10.28 10.28 0 1 0 25.45 49a10.28 10.28 0 0 0-10.28-10.24zm0 17.53A7.25 7.25 0 1 1 22.42 49a7.26 7.26 0 0 1-7.25 7.29z"
  }), _react["default"].createElement("circle", {
    cx: "15.17",
    cy: "49.04",
    r: "3.79"
  }), _react["default"].createElement("path", {
    d: "M34.49 22.5h28.9a1.52 1.52 0 1 0 0-3h-28.9a1.52 1.52 0 0 0 0 3zM63.39 47.52h-28.9a1.52 1.52 0 1 0 0 3h28.9a1.52 1.52 0 1 0 0-3z"
  })),
  height: undefined,
  width: undefined
});
IconRadio.displayName = 'IconRadio';
var _default = IconRadio;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/radio.js
// module id = 591
// module chunks = 0